import {pageInfo} from '../api';
import {plant} from '../../../../../api'

const hikFaceEvent = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => {
        // 放行状态颜色
        if (item.facePassStatusDesc === '不可放行') {
          item.facePassStatusDescColor = '#F56C6C';
        } else if (item.facePassStatusDesc === '可放行') {
          item.facePassStatusDescColor = '#67C23A';
        } else {
          item.facePassStatusDescColor = '#909399';
        }
        return {...item, btns: [true]};
      });
    },
    PLANT(state, data) {
      state.plantObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    }
  }
}
export default hikFaceEvent



// WEBPACK FOOTER //
// ./src/page/int/face/hikFaceEvent/store/hikFaceEvent.store.js